// add content/page module imports here
import {PlanningOverzichtModule} from './overzicht/planningoverzicht.module';
import {MultiSelectModule} from 'primeng/multiselect';
import { NgModule } from '@angular/core';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatDatepickerModule} from '@angular/material/datepicker';
@NgModule({
  imports: [
    MultiSelectModule,
    MatCheckboxModule,
    MatDatepickerModule
  ],

  exports: [
    PlanningOverzichtModule,
  ]
})

export class PlanningModule {  };

